'use client'
import { forwardRef, Spinner as ChakraSpinner } from '@chakra-ui/react'
import { LegacyRef } from 'react'

import { SpinnerProps } from './Spinner.types'

export default forwardRef(function Spinner(
  props: SpinnerProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraSpinner {...props} ref={ref} translate="no" />
})
